import React from 'react';
import { Link } from 'react-router-dom';
import './styles.css';

import logo from '../../assets/logo.png';

function Header() {
  return (
    <header id="header">
      <img alt="Logo" className="logo" src={logo} height="180px"/>
      <div id="header-menu">
        <div className="header-menu-navigation"><Link to="/">Home</Link></div>
        <div className="header-menu-navigation"><Link to="/institucional">Institucional</Link></div>
        <div className="header-menu-navigation"><Link to="/emprestimos">Empréstimos</Link></div>
        <div className="header-menu-navigation"><Link to="/associe-se">Associe-se</Link></div>
        <div className="header-menu-navigation"><Link to="/noticias">Notícias</Link></div>
        <div className="header-menu-navigation"><Link to="/contato">Contato</Link></div>
      </div>
    </header>
  )
}

export default Header;